import api from './api';

export interface MarcaTarjeta {
    codigoMarca: number;
    nombreMarca: string;
    limVenComercio?: number;
    limVenEstServ?: number;
    limVenSupermer?: number;
    descuentoContado?: number;
    nroCuenta?: number;
    numeroComercio?: string;
    [key: string]: any; // Para campos adicionales que puedan venir del backend
}

const marcasTarjetasService = {
    getMarcasTarjetas: async (): Promise<MarcaTarjeta[]> => {
        const response = await api.get<MarcaTarjeta[]>('/api/MarcasTarjetas');
        return response.data;
    },

    getMarcaTarjeta: async (codigoMarca: number): Promise<MarcaTarjeta> => {
        const response = await api.get<MarcaTarjeta>(`/api/MarcasTarjetas/${codigoMarca}`);
        return response.data;
    },

    createMarcaTarjeta: async (marcaTarjeta: MarcaTarjeta): Promise<MarcaTarjeta> => {
        const response = await api.post<MarcaTarjeta>('/api/MarcasTarjetas', marcaTarjeta);
        return response.data;
    },

    updateMarcaTarjeta: async (codigoMarca: number, marcaTarjeta: MarcaTarjeta): Promise<void> => {
        await api.put(`/api/MarcasTarjetas/${codigoMarca}`, marcaTarjeta);
    },

    deleteMarcaTarjeta: async (codigoMarca: number): Promise<void> => {
        await api.delete(`/api/MarcasTarjetas/${codigoMarca}`);
    }
};

export default marcasTarjetasService;

